var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "url(#paint0_linear_64_335)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6588 39.288V25.9133H31.1204L31.9664 20.3841H26.6588V16.7886C26.6588 15.2779 27.4041 13.7975 29.7809 13.7975H32.198V9.08407C32.198 9.08407 30.0025 8.71143 27.9177 8.71143C23.5467 8.71143 20.6865 11.3602 20.6865 16.1541V20.374H15.822V25.9032H20.6865V39.2779H26.6588V39.288Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_64_335",
    x1: 7.02869,
    y1: 7.02989,
    x2: 40.9719,
    y2: 40.9731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1677F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1756,
    stopColor: "#186EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4613,
    stopColor: "#1E56D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8194,
    stopColor: "#262EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B189C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.0e03c1b83d281c2196406e3f2a08c764.svg";
export { ForwardRef as ReactComponent };